import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_offer_female_wrkrs_in_the_supply_chain_ie_female_w'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_offer_female_wrkrs_in_the_supply_chain_ie_female_w',
  name: 'Does the facility offer female workers in the supply chain (i.e. female workers at suppliers/subcontractors to the facility) any of the following types of professional developmental opportunities?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PROFESSIONAL_TRAINING',
      text: 'Professional Training',
      externalIds: [
        {
          id: 'ab-com-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-com-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MENTORING__SPONSORSHIP_PROGRAM',
      text: 'Mentoring/ sponsorship program',
      externalIds: [
        {
          id: 'ab-com-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-com-6f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'EDUCATIONAL_OPPORTUNITIES',
      text: 'Educational opportunities',
      externalIds: [
        {
          id: 'ab-com-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-com-8f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-com-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-com-10f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-com-11x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PROFESSIONAL_TRAINING',
                'MENTORING__SPONSORSHIP_PROGRAM',
                'EDUCATIONAL_OPPORTUNITIES',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 24640,
  sectionId: '2.2.2.4',
  impactArea: 'Community Impact',
  impactAreaId: 'COMMUNITY_IMPACT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
